<template>
      <div class="box box-primary">
        <div class="box-header">
          <div class="row">
            <div class="col-md-3">
              <h3>{{ $t('fileBrowser.files.title') }}</h3>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-6 text-right">
              <BrowserFileUploadButton
                :disabled="!canUpload"
                v-if="selectedNode"
              ></BrowserFileUploadButton>

              <file-upload
                ref="upload"
                name="file"
                v-model="uploadFiles"
                @input-file="inputFile"
                v-bind:post-action="urlPost + '/drive/addFile?law_firm_id=' + selected"
                :headers="{'Authorization': 'Bearer ' + main.token}"
                :data="{path: selectedNode && selectedNode.data.path, matterId: getMatterId}"
                :multiple="true"
                :drop="canUpload"
                :drop-directory="canUpload"
                :size="500000000"
                :thread="3"
                :disabled="!canUpload"
              ></file-upload>
            </div>
          </div>
        </div>
        <div class="box-body">
          <div v-if="!selectedNode || (selectedNode && selectedNode.data && selectedNode.data.files && selectedNode.data.files.length < 1)">
            {{ $t('fileBrowser.files.select_folder') }}
          </div>
          <div v-else class="row fileDetails" v-for="node in selectedNode.data.files" v-bind:key="'files-'+node.data.id">
            <div class="col-md-1 fileType">
              <i :class="getFileClassIcon(node.text)"  aria-hidden="true"></i>
            </div>
            <div class="col-md-4 fileName">
              {{ node.text }}
            </div>
            <div class="col-md-3 fileDate">
              {{ $d(new Date(node.data.fileDate), 'long') }}
            </div>
            <div class="col-md-2 fileSize">
              {{ getFileSize(node.data.fileSize) }}
            </div>
            <div class="col-md-2 fileActions">
              <button class="btn btn-danger" v-on:click="deleteFile(node)" v-if="canDelete(node)">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
              <button class="btn btn-default" v-on:click="downloadFile(node)">
                <i class="fa fa-download" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import VueUploadComponent from 'vue-upload-component'
import BrowserFileUploadButton from './BrowserFileUploadButton'
import Store from '../../store/store'
import DriveApi from '../../api/drive'

const prettyBytes = require('pretty-bytes')

export default {
  name: 'BrowserFileList',
  components: {
    'file-upload': VueUploadComponent,
    BrowserFileUploadButton
  },
  data: () => {
    return {
      urlPost: process.env.VUE_APP_API_BASE_URL,
      treeFilter: '',
      treeOptions: {
        multiple: false,
        filter: {
          plainList: true
        },
        store: {
          store: Store,
          getter: () => {
            return Store.getters['drive/getTree']
          },
          dispatcher (tree) {
            Store.dispatch('drive/setTree', tree)
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('drive', {
      addOneFile: 'addFile'
    }),
    downloadFile (node) {
      if (node.data.downloadUrl) { // Sharepoint only
        const link = document.createElement('a')
        link.href = node.data.downloadUrl
        link.click()

        return
      }
      DriveApi.download(node)
        .then(response => {
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = node.text
          link.click()
        })
    },
    deleteFile (file) {
      Store.dispatch('drive/deleteFile', { file: file })
    },
    getFileClassIcon (fileName) {
      let ext = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2)
      switch (ext) {
        case 'doc':
        case 'docx':
          return 'fa fa-file-word-o'
        case 'txt':
          return 'fa fa-file-text-o'
        case 'pdf':
          return 'fa fa-file-pdf-o'
        case 'zip':
        case 'rar':
          return 'fa fa-file-archive-o'
        case 'csv':
        case 'xls':
        case 'xlsx':
          return 'fa fa-file-excel-o'
        case 'ppt':
        case 'pptx':
          return 'fa fa-file-powerpoint-o'
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'bmp':
          return 'fa fa-file-image-o'
        default:
          return 'fa fa-file-o'
      }
    },
    getFileSize (fileSize) {
      return prettyBytes(fileSize)
    },
    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
        // Add file
        newFile.node = this.$store.state.drive.selectedNode
      }

      if (newFile && oldFile) {
        // Start upload
        if (newFile.active !== oldFile.active) {
          // max size
          if (newFile.size <= 0 && newFile.size > 500000000) { // 500 Mo
            newFile = this.$refs.upload.update(newFile, { data: { path: this.selectedNode.data.path } })
          }
        }

        // Upload progress
        if (newFile.progress !== oldFile.progress) {
          //  will be used in futur with chunk
        }

        // Upload error
        if (newFile.error !== oldFile.error) {
          //  for specific action (toaster maybe ?)
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          let stateFile = {
            text: newFile.response.file_name,
            data: {
              id: newFile.response.file_id,
              fileDate: new Date(),
              fileSize: newFile.response.file_size,
              path: newFile.response.path,
              permissions: newFile.response.permissions
            }
          }

          this.addOneFile({
            newFile: stateFile,
            TreePosition: newFile.node !== undefined ? newFile.node : this.$store.state.drive.selectedNode
          })
        }
      }

      // Automatic upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    canDelete (file) {
      return file && file.data.permissions && file.data.permissions.includes('delete')
    }
  },
  computed: {
    ...mapState('drive', [
      'selectedNode'
    ]),
    ...mapState('lawFirms', [
      'selected'
    ]),
    ...mapState('user', [
      'main'
    ]),
    ...mapGetters('drive', [
      'getMatterId'
    ]),
    canUpload () {
      return this.selectedNode && this.selectedNode.data.permissions && this.selectedNode.data.permissions.includes('create')
    },
    uploadFiles: {
      get () {
        return this.$store.state.drive.uploadFiles
      },
      set (val) {
        this.$store.dispatch('drive/setUploadFiles', { uploadFiles: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .fileDetails {
    min-height: 45px;
    line-height: 45px;
    display: flex;

    &:hover {
      background-color: #EEEEEE;
    }
    .fileType {
      text-align: center;
      width: 30px;
    }
    .fileType i {
      line-height: inherit;
    }
    .fileName {
      flex: 1;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .fileDate {
      width: 180px;
    }
    .fileSize {
      width: 120px;
    }
    .fileActions {
      text-align: right;
      width: 80px;
    }
  }
</style>
